export const useLoading = () => {
    const loading = useState('loading', () => false);

    const setLoading = (val: boolean) => {
        loading.value = val;
    }

    return {
        loading,
        setLoading
    }
}